import { createAsyncThunk } from '@reduxjs/toolkit';

import { CatalogItem } from 'entities/CatalogItem/model/types/CatalogItemSchema';
import { ExtendedAxiosRequestConfig } from 'shared/api/types';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const fetchInventoryItems = createAsyncThunk<
    CatalogItem[],
    string,
    ThunkConfig<string>
>('catalogItem/fetchInventoryItems', async (catalogId, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
        const config: ExtendedAxiosRequestConfig = {
            params: { isInventory: true },
            keysToNotConvert: ['specifications'],
        };

        const response = await extra.api.get<CatalogItem[]>(
            `/v1/catalogs/${catalogId}`,
            config,
        );

        return response.data;
    } catch (e) {
        return rejectWithValue('error');
    }
});
